// GENERATED by scripts/import-forbes.mjs. Forbes value history ($B) per team from the
// saved list exports; the list a team was last seen on is in forbes-breakdown.js.
export const forbesValues = {
  "new-york-yankees": [
    {
      "year": 2017,
      "value": 3.7
    },
    {
      "year": 2018,
      "value": 4
    },
    {
      "year": 2019,
      "value": 4.6
    },
    {
      "year": 2020,
      "value": 5
    },
    {
      "year": 2021,
      "value": 5.25
    },
    {
      "year": 2022,
      "value": 6
    },
    {
      "year": 2023,
      "value": 7.1
    },
    {
      "year": 2024,
      "value": 7.55
    },
    {
      "year": 2025,
      "value": 8.2
    },
    {
      "year": 2026,
      "value": 8.5
    }
  ],
  "los-angeles-dodgers": [
    {
      "year": 2017,
      "value": 2.75
    },
    {
      "year": 2018,
      "value": 3
    },
    {
      "year": 2019,
      "value": 3.3
    },
    {
      "year": 2020,
      "value": 3.4
    },
    {
      "year": 2021,
      "value": 3.57
    },
    {
      "year": 2022,
      "value": 4.075
    },
    {
      "year": 2023,
      "value": 4.8
    },
    {
      "year": 2024,
      "value": 5.45
    },
    {
      "year": 2025,
      "value": 6.8
    },
    {
      "year": 2026,
      "value": 7.8
    }
  ],
  "boston-red-sox": [
    {
      "year": 2017,
      "value": 2.7
    },
    {
      "year": 2018,
      "value": 2.8
    },
    {
      "year": 2019,
      "value": 3.2
    },
    {
      "year": 2020,
      "value": 3.3
    },
    {
      "year": 2021,
      "value": 3.465
    },
    {
      "year": 2022,
      "value": 3.9
    },
    {
      "year": 2023,
      "value": 4.5
    },
    {
      "year": 2024,
      "value": 4.5
    },
    {
      "year": 2025,
      "value": 4.8
    },
    {
      "year": 2026,
      "value": 5.25
    }
  ],
  "chicago-cubs": [
    {
      "year": 2017,
      "value": 2.675
    },
    {
      "year": 2018,
      "value": 2.9
    },
    {
      "year": 2019,
      "value": 3.1
    },
    {
      "year": 2020,
      "value": 3.2
    },
    {
      "year": 2021,
      "value": 3.36
    },
    {
      "year": 2022,
      "value": 3.8
    },
    {
      "year": 2023,
      "value": 4.1
    },
    {
      "year": 2024,
      "value": 4.225
    },
    {
      "year": 2025,
      "value": 4.6
    },
    {
      "year": 2026,
      "value": 5
    }
  ],
  "san-francisco-giants": [
    {
      "year": 2017,
      "value": 2.65
    },
    {
      "year": 2018,
      "value": 2.85
    },
    {
      "year": 2019,
      "value": 3
    },
    {
      "year": 2020,
      "value": 3.1
    },
    {
      "year": 2021,
      "value": 3.175
    },
    {
      "year": 2022,
      "value": 3.5
    },
    {
      "year": 2023,
      "value": 3.7
    },
    {
      "year": 2024,
      "value": 3.8
    },
    {
      "year": 2025,
      "value": 4
    },
    {
      "year": 2026,
      "value": 4.05
    }
  ],
  "new-york-mets": [
    {
      "year": 2017,
      "value": 2
    },
    {
      "year": 2018,
      "value": 2.1
    },
    {
      "year": 2019,
      "value": 2.3
    },
    {
      "year": 2020,
      "value": 2.4
    },
    {
      "year": 2021,
      "value": 2.45
    },
    {
      "year": 2022,
      "value": 2.65
    },
    {
      "year": 2023,
      "value": 2.9
    },
    {
      "year": 2024,
      "value": 3
    },
    {
      "year": 2025,
      "value": 3.2
    },
    {
      "year": 2026,
      "value": 3.5
    }
  ],
  "philadelphia-phillies": [
    {
      "year": 2017,
      "value": 1.65
    },
    {
      "year": 2018,
      "value": 1.7
    },
    {
      "year": 2019,
      "value": 1.85
    },
    {
      "year": 2020,
      "value": 2
    },
    {
      "year": 2021,
      "value": 2.05
    },
    {
      "year": 2022,
      "value": 2.3
    },
    {
      "year": 2023,
      "value": 2.575
    },
    {
      "year": 2024,
      "value": 2.925
    },
    {
      "year": 2025,
      "value": 3.1
    },
    {
      "year": 2026,
      "value": 3.4
    }
  ],
  "atlanta-braves": [
    {
      "year": 2017,
      "value": 1.5
    },
    {
      "year": 2018,
      "value": 1.625
    },
    {
      "year": 2019,
      "value": 1.7
    },
    {
      "year": 2020,
      "value": 1.8
    },
    {
      "year": 2021,
      "value": 1.875
    },
    {
      "year": 2022,
      "value": 2.1
    },
    {
      "year": 2023,
      "value": 2.6
    },
    {
      "year": 2024,
      "value": 2.8
    },
    {
      "year": 2025,
      "value": 3
    },
    {
      "year": 2026,
      "value": 3.35
    }
  ],
  "houston-astros": [
    {
      "year": 2017,
      "value": 1.45
    },
    {
      "year": 2018,
      "value": 1.65
    },
    {
      "year": 2019,
      "value": 1.775
    },
    {
      "year": 2020,
      "value": 1.85
    },
    {
      "year": 2021,
      "value": 1.87
    },
    {
      "year": 2022,
      "value": 1.98
    },
    {
      "year": 2023,
      "value": 2.25
    },
    {
      "year": 2024,
      "value": 2.425
    },
    {
      "year": 2025,
      "value": 2.8
    },
    {
      "year": 2026,
      "value": 3.2
    }
  ],
  "san-diego-padres": [
    {
      "year": 2017,
      "value": 1.125
    },
    {
      "year": 2018,
      "value": 1.27
    },
    {
      "year": 2019,
      "value": 1.35
    },
    {
      "year": 2020,
      "value": 1.45
    },
    {
      "year": 2021,
      "value": 1.5
    },
    {
      "year": 2022,
      "value": 1.575
    },
    {
      "year": 2023,
      "value": 1.75
    },
    {
      "year": 2024,
      "value": 1.78
    },
    {
      "year": 2025,
      "value": 1.95
    },
    {
      "year": 2026,
      "value": 3.1
    }
  ],
  "los-angeles-angels": [
    {
      "year": 2017,
      "value": 1.75
    },
    {
      "year": 2018,
      "value": 1.8
    },
    {
      "year": 2019,
      "value": 1.9
    },
    {
      "year": 2020,
      "value": 1.975
    },
    {
      "year": 2021,
      "value": 2.025
    },
    {
      "year": 2022,
      "value": 2.2
    },
    {
      "year": 2023,
      "value": 2.7
    },
    {
      "year": 2024,
      "value": 2.7
    },
    {
      "year": 2025,
      "value": 2.75
    },
    {
      "year": 2026,
      "value": 2.8
    }
  ],
  "st-louis-cardinals": [
    {
      "year": 2017,
      "value": 1.8
    },
    {
      "year": 2018,
      "value": 1.9
    },
    {
      "year": 2019,
      "value": 2.1
    },
    {
      "year": 2020,
      "value": 2.2
    },
    {
      "year": 2021,
      "value": 2.245
    },
    {
      "year": 2022,
      "value": 2.45
    },
    {
      "year": 2023,
      "value": 2.55
    },
    {
      "year": 2024,
      "value": 2.55
    },
    {
      "year": 2025,
      "value": 2.55
    },
    {
      "year": 2026,
      "value": 2.75
    }
  ],
  "texas-rangers": [
    {
      "year": 2017,
      "value": 1.55
    },
    {
      "year": 2018,
      "value": 1.6
    },
    {
      "year": 2019,
      "value": 1.65
    },
    {
      "year": 2020,
      "value": 1.75
    },
    {
      "year": 2021,
      "value": 1.785
    },
    {
      "year": 2022,
      "value": 2.05
    },
    {
      "year": 2023,
      "value": 2.225
    },
    {
      "year": 2024,
      "value": 2.4
    },
    {
      "year": 2025,
      "value": 2.45
    },
    {
      "year": 2026,
      "value": 2.7
    }
  ],
  "toronto-blue-jays": [
    {
      "year": 2017,
      "value": 1.3
    },
    {
      "year": 2018,
      "value": 1.35
    },
    {
      "year": 2019,
      "value": 1.5
    },
    {
      "year": 2020,
      "value": 1.625
    },
    {
      "year": 2021,
      "value": 1.675
    },
    {
      "year": 2022,
      "value": 1.78
    },
    {
      "year": 2023,
      "value": 2.1
    },
    {
      "year": 2024,
      "value": 2.1
    },
    {
      "year": 2025,
      "value": 2.15
    },
    {
      "year": 2026,
      "value": 2.5
    }
  ],
  "seattle-mariners": [
    {
      "year": 2017,
      "value": 1.4
    },
    {
      "year": 2018,
      "value": 1.45
    },
    {
      "year": 2019,
      "value": 1.575
    },
    {
      "year": 2020,
      "value": 1.6
    },
    {
      "year": 2021,
      "value": 1.63
    },
    {
      "year": 2022,
      "value": 1.7
    },
    {
      "year": 2023,
      "value": 2.2
    },
    {
      "year": 2024,
      "value": 2.2
    },
    {
      "year": 2025,
      "value": 2.2
    },
    {
      "year": 2026,
      "value": 2.35
    }
  ],
  "washington-nationals": [
    {
      "year": 2017,
      "value": 1.6
    },
    {
      "year": 2018,
      "value": 1.675
    },
    {
      "year": 2019,
      "value": 1.75
    },
    {
      "year": 2020,
      "value": 1.9
    },
    {
      "year": 2021,
      "value": 1.925
    },
    {
      "year": 2022,
      "value": 2
    },
    {
      "year": 2023,
      "value": 2
    },
    {
      "year": 2024,
      "value": 2
    },
    {
      "year": 2025,
      "value": 2.1
    },
    {
      "year": 2026,
      "value": 2.15
    }
  ],
  "baltimore-orioles": [
    {
      "year": 2017,
      "value": 1.175
    },
    {
      "year": 2018,
      "value": 1.2
    },
    {
      "year": 2019,
      "value": 1.28
    },
    {
      "year": 2020,
      "value": 1.4
    },
    {
      "year": 2021,
      "value": 1.43
    },
    {
      "year": 2022,
      "value": 1.375
    },
    {
      "year": 2023,
      "value": 1.713
    },
    {
      "year": 2024,
      "value": 1.725
    },
    {
      "year": 2025,
      "value": 1.9
    },
    {
      "year": 2026,
      "value": 2.1
    }
  ],
  "oakland-athletics": [
    {
      "year": 2017,
      "value": 0.88
    },
    {
      "year": 2018,
      "value": 1.02
    },
    {
      "year": 2019,
      "value": 1.1
    },
    {
      "year": 2020,
      "value": 1.1
    },
    {
      "year": 2021,
      "value": 1.125
    },
    {
      "year": 2022,
      "value": 1.18
    },
    {
      "year": 2023,
      "value": 1.18
    },
    {
      "year": 2024,
      "value": 1.2
    },
    {
      "year": 2025,
      "value": 1.8
    },
    {
      "year": 2026,
      "value": 2
    }
  ],
  "arizona-diamondbacks": [
    {
      "year": 2017,
      "value": 1.15
    },
    {
      "year": 2018,
      "value": 1.21
    },
    {
      "year": 2019,
      "value": 1.29
    },
    {
      "year": 2020,
      "value": 1.29
    },
    {
      "year": 2021,
      "value": 1.32
    },
    {
      "year": 2022,
      "value": 1.38
    },
    {
      "year": 2023,
      "value": 1.38
    },
    {
      "year": 2024,
      "value": 1.425
    },
    {
      "year": 2025,
      "value": 1.6
    },
    {
      "year": 2026,
      "value": 1.96
    }
  ],
  "chicago-white-sox": [
    {
      "year": 2017,
      "value": 1.35
    },
    {
      "year": 2018,
      "value": 1.5
    },
    {
      "year": 2019,
      "value": 1.6
    },
    {
      "year": 2020,
      "value": 1.65
    },
    {
      "year": 2021,
      "value": 1.685
    },
    {
      "year": 2022,
      "value": 1.76
    },
    {
      "year": 2023,
      "value": 2.05
    },
    {
      "year": 2024,
      "value": 2.05
    },
    {
      "year": 2025,
      "value": 2
    },
    {
      "year": 2026,
      "value": 1.94
    }
  ],
  "milwaukee-brewers": [
    {
      "year": 2017,
      "value": 0.925
    },
    {
      "year": 2018,
      "value": 1.03
    },
    {
      "year": 2019,
      "value": 1.175
    },
    {
      "year": 2020,
      "value": 1.2
    },
    {
      "year": 2021,
      "value": 1.22
    },
    {
      "year": 2022,
      "value": 1.28
    },
    {
      "year": 2023,
      "value": 1.605
    },
    {
      "year": 2024,
      "value": 1.605
    },
    {
      "year": 2025,
      "value": 1.7
    },
    {
      "year": 2026,
      "value": 1.9
    }
  ],
  "detroit-tigers": [
    {
      "year": 2017,
      "value": 1.2
    },
    {
      "year": 2018,
      "value": 1.225
    },
    {
      "year": 2019,
      "value": 1.25
    },
    {
      "year": 2020,
      "value": 1.25
    },
    {
      "year": 2021,
      "value": 1.26
    },
    {
      "year": 2022,
      "value": 1.4
    },
    {
      "year": 2023,
      "value": 1.45
    },
    {
      "year": 2024,
      "value": 1.45
    },
    {
      "year": 2025,
      "value": 1.55
    },
    {
      "year": 2026,
      "value": 1.8
    }
  ],
  "minnesota-twins": [
    {
      "year": 2017,
      "value": 1.025
    },
    {
      "year": 2018,
      "value": 1.15
    },
    {
      "year": 2019,
      "value": 1.2
    },
    {
      "year": 2020,
      "value": 1.3
    },
    {
      "year": 2021,
      "value": 1.325
    },
    {
      "year": 2022,
      "value": 1.39
    },
    {
      "year": 2023,
      "value": 1.39
    },
    {
      "year": 2024,
      "value": 1.46
    },
    {
      "year": 2025,
      "value": 1.5
    },
    {
      "year": 2026,
      "value": 1.71
    }
  ],
  "tampa-bay-rays": [
    {
      "year": 2017,
      "value": 0.825
    },
    {
      "year": 2018,
      "value": 0.9
    },
    {
      "year": 2019,
      "value": 1.01
    },
    {
      "year": 2020,
      "value": 1.05
    },
    {
      "year": 2021,
      "value": 1.055
    },
    {
      "year": 2022,
      "value": 1.1
    },
    {
      "year": 2023,
      "value": 1.25
    },
    {
      "year": 2024,
      "value": 1.25
    },
    {
      "year": 2025,
      "value": 1.25
    },
    {
      "year": 2026,
      "value": 1.7
    }
  ],
  "colorado-rockies": [
    {
      "year": 2017,
      "value": 1
    },
    {
      "year": 2018,
      "value": 1.1
    },
    {
      "year": 2019,
      "value": 1.225
    },
    {
      "year": 2020,
      "value": 1.275
    },
    {
      "year": 2021,
      "value": 1.3
    },
    {
      "year": 2022,
      "value": 1.385
    },
    {
      "year": 2023,
      "value": 1.475
    },
    {
      "year": 2024,
      "value": 1.475
    },
    {
      "year": 2025,
      "value": 1.475
    },
    {
      "year": 2026,
      "value": 1.68
    }
  ],
  "cleveland-guardians": [
    {
      "year": 2017,
      "value": 0.92
    },
    {
      "year": 2018,
      "value": 1.045
    },
    {
      "year": 2019,
      "value": 1.15
    },
    {
      "year": 2020,
      "value": 1.15
    },
    {
      "year": 2021,
      "value": 1.16
    },
    {
      "year": 2022,
      "value": 1.3
    },
    {
      "year": 2023,
      "value": 1.3
    },
    {
      "year": 2024,
      "value": 1.35
    },
    {
      "year": 2025,
      "value": 1.4
    },
    {
      "year": 2026,
      "value": 1.66
    }
  ],
  "kansas-city-royals": [
    {
      "year": 2017,
      "value": 0.95
    },
    {
      "year": 2018,
      "value": 1.015
    },
    {
      "year": 2019,
      "value": 1.025
    },
    {
      "year": 2020,
      "value": 1.025
    },
    {
      "year": 2021,
      "value": 1.06
    },
    {
      "year": 2022,
      "value": 1.11
    },
    {
      "year": 2023,
      "value": 1.2
    },
    {
      "year": 2024,
      "value": 1.225
    },
    {
      "year": 2025,
      "value": 1.3
    },
    {
      "year": 2026,
      "value": 1.64
    }
  ],
  "pittsburgh-pirates": [
    {
      "year": 2017,
      "value": 1.25
    },
    {
      "year": 2018,
      "value": 1.26
    },
    {
      "year": 2019,
      "value": 1.275
    },
    {
      "year": 2020,
      "value": 1.26
    },
    {
      "year": 2021,
      "value": 1.285
    },
    {
      "year": 2022,
      "value": 1.32
    },
    {
      "year": 2023,
      "value": 1.32
    },
    {
      "year": 2024,
      "value": 1.32
    },
    {
      "year": 2025,
      "value": 1.35
    },
    {
      "year": 2026,
      "value": 1.62
    }
  ],
  "cincinnati-reds": [
    {
      "year": 2017,
      "value": 0.915
    },
    {
      "year": 2018,
      "value": 1.01
    },
    {
      "year": 2019,
      "value": 1.05
    },
    {
      "year": 2020,
      "value": 1.075
    },
    {
      "year": 2021,
      "value": 1.085
    },
    {
      "year": 2022,
      "value": 1.19
    },
    {
      "year": 2023,
      "value": 1.19
    },
    {
      "year": 2024,
      "value": 1.255
    },
    {
      "year": 2025,
      "value": 1.325
    },
    {
      "year": 2026,
      "value": 1.6
    }
  ],
  "miami-marlins": [
    {
      "year": 2017,
      "value": 0.94
    },
    {
      "year": 2018,
      "value": 1
    },
    {
      "year": 2019,
      "value": 1
    },
    {
      "year": 2020,
      "value": 0.98
    },
    {
      "year": 2021,
      "value": 0.99
    },
    {
      "year": 2022,
      "value": 0.99
    },
    {
      "year": 2023,
      "value": 1
    },
    {
      "year": 2024,
      "value": 1
    },
    {
      "year": 2025,
      "value": 1.05
    },
    {
      "year": 2026,
      "value": 1.5
    }
  ],
  "golden-state-warriors": [
    {
      "year": 2016,
      "value": 2.6
    },
    {
      "year": 2017,
      "value": 3.1
    },
    {
      "year": 2018,
      "value": 3.5
    },
    {
      "year": 2019,
      "value": 4.3
    },
    {
      "year": 2020,
      "value": 4.7
    },
    {
      "year": 2021,
      "value": 5.6
    },
    {
      "year": 2022,
      "value": 7
    },
    {
      "year": 2023,
      "value": 7.7
    },
    {
      "year": 2024,
      "value": 8.8
    },
    {
      "year": 2025,
      "value": 11
    }
  ],
  "los-angeles-lakers": [
    {
      "year": 2016,
      "value": 3
    },
    {
      "year": 2017,
      "value": 3.3
    },
    {
      "year": 2018,
      "value": 3.7
    },
    {
      "year": 2019,
      "value": 4.4
    },
    {
      "year": 2020,
      "value": 4.6
    },
    {
      "year": 2021,
      "value": 5.5
    },
    {
      "year": 2022,
      "value": 5.9
    },
    {
      "year": 2023,
      "value": 6.4
    },
    {
      "year": 2024,
      "value": 7.1
    },
    {
      "year": 2025,
      "value": 10
    }
  ],
  "new-york-knicks": [
    {
      "year": 2016,
      "value": 3.3
    },
    {
      "year": 2017,
      "value": 3.6
    },
    {
      "year": 2018,
      "value": 4
    },
    {
      "year": 2019,
      "value": 4.6
    },
    {
      "year": 2020,
      "value": 5
    },
    {
      "year": 2021,
      "value": 5.8
    },
    {
      "year": 2022,
      "value": 6.1
    },
    {
      "year": 2023,
      "value": 6.6
    },
    {
      "year": 2024,
      "value": 7.5
    },
    {
      "year": 2025,
      "value": 9.75
    }
  ],
  "los-angeles-clippers": [
    {
      "year": 2016,
      "value": 2
    },
    {
      "year": 2017,
      "value": 2.15
    },
    {
      "year": 2018,
      "value": 2.2
    },
    {
      "year": 2019,
      "value": 2.6
    },
    {
      "year": 2020,
      "value": 2.75
    },
    {
      "year": 2021,
      "value": 3.3
    },
    {
      "year": 2022,
      "value": 3.9
    },
    {
      "year": 2023,
      "value": 4.65
    },
    {
      "year": 2024,
      "value": 5.5
    },
    {
      "year": 2025,
      "value": 7.5
    }
  ],
  "boston-celtics": [
    {
      "year": 2016,
      "value": 2.2
    },
    {
      "year": 2017,
      "value": 2.5
    },
    {
      "year": 2018,
      "value": 2.8
    },
    {
      "year": 2019,
      "value": 3.1
    },
    {
      "year": 2020,
      "value": 3.2
    },
    {
      "year": 2021,
      "value": 3.55
    },
    {
      "year": 2022,
      "value": 4
    },
    {
      "year": 2023,
      "value": 4.7
    },
    {
      "year": 2024,
      "value": 6
    },
    {
      "year": 2025,
      "value": 6.7
    }
  ],
  "chicago-bulls": [
    {
      "year": 2016,
      "value": 2.5
    },
    {
      "year": 2017,
      "value": 2.6
    },
    {
      "year": 2018,
      "value": 2.9
    },
    {
      "year": 2019,
      "value": 3.2
    },
    {
      "year": 2020,
      "value": 3.3
    },
    {
      "year": 2021,
      "value": 3.65
    },
    {
      "year": 2022,
      "value": 4.1
    },
    {
      "year": 2023,
      "value": 4.6
    },
    {
      "year": 2024,
      "value": 5
    },
    {
      "year": 2025,
      "value": 6
    }
  ],
  "houston-rockets": [
    {
      "year": 2016,
      "value": 1.65
    },
    {
      "year": 2017,
      "value": 2.2
    },
    {
      "year": 2018,
      "value": 2.3
    },
    {
      "year": 2019,
      "value": 2.475
    },
    {
      "year": 2020,
      "value": 2.5
    },
    {
      "year": 2021,
      "value": 2.75
    },
    {
      "year": 2022,
      "value": 3.2
    },
    {
      "year": 2023,
      "value": 4.4
    },
    {
      "year": 2024,
      "value": 4.9
    },
    {
      "year": 2025,
      "value": 5.9
    }
  ],
  "miami-heat": [
    {
      "year": 2016,
      "value": 1.35
    },
    {
      "year": 2017,
      "value": 1.7
    },
    {
      "year": 2018,
      "value": 1.75
    },
    {
      "year": 2019,
      "value": 1.95
    },
    {
      "year": 2020,
      "value": 2
    },
    {
      "year": 2021,
      "value": 2.3
    },
    {
      "year": 2022,
      "value": 3
    },
    {
      "year": 2023,
      "value": 3.9
    },
    {
      "year": 2024,
      "value": 4.25
    },
    {
      "year": 2025,
      "value": 5.7
    }
  ],
  "brooklyn-nets": [
    {
      "year": 2016,
      "value": 1.8
    },
    {
      "year": 2017,
      "value": 2.3
    },
    {
      "year": 2018,
      "value": 2.35
    },
    {
      "year": 2019,
      "value": 2.5
    },
    {
      "year": 2020,
      "value": 2.65
    },
    {
      "year": 2021,
      "value": 3.2
    },
    {
      "year": 2022,
      "value": 3.5
    },
    {
      "year": 2023,
      "value": 3.85
    },
    {
      "year": 2024,
      "value": 4.8
    },
    {
      "year": 2025,
      "value": 5.6
    }
  ],
  "philadelphia-76ers": [
    {
      "year": 2016,
      "value": 0.8
    },
    {
      "year": 2017,
      "value": 1.18
    },
    {
      "year": 2018,
      "value": 1.65
    },
    {
      "year": 2019,
      "value": 2
    },
    {
      "year": 2020,
      "value": 2.075
    },
    {
      "year": 2021,
      "value": 2.45
    },
    {
      "year": 2022,
      "value": 3.15
    },
    {
      "year": 2023,
      "value": 4.3
    },
    {
      "year": 2024,
      "value": 4.6
    },
    {
      "year": 2025,
      "value": 5.45
    }
  ],
  "phoenix-suns": [
    {
      "year": 2016,
      "value": 1.1
    },
    {
      "year": 2017,
      "value": 1.28
    },
    {
      "year": 2018,
      "value": 1.5
    },
    {
      "year": 2019,
      "value": 1.625
    },
    {
      "year": 2020,
      "value": 1.7
    },
    {
      "year": 2021,
      "value": 1.8
    },
    {
      "year": 2022,
      "value": 2.7
    },
    {
      "year": 2023,
      "value": 4
    },
    {
      "year": 2024,
      "value": 4.3
    },
    {
      "year": 2025,
      "value": 5.425
    }
  ],
  "toronto-raptors": [
    {
      "year": 2016,
      "value": 1.125
    },
    {
      "year": 2017,
      "value": 1.4
    },
    {
      "year": 2018,
      "value": 1.675
    },
    {
      "year": 2019,
      "value": 2.1
    },
    {
      "year": 2020,
      "value": 2.15
    },
    {
      "year": 2021,
      "value": 2.475
    },
    {
      "year": 2022,
      "value": 3.1
    },
    {
      "year": 2023,
      "value": 4.1
    },
    {
      "year": 2024,
      "value": 4.4
    },
    {
      "year": 2025,
      "value": 5.4
    }
  ],
  "dallas-mavericks": [
    {
      "year": 2016,
      "value": 1.45
    },
    {
      "year": 2017,
      "value": 1.9
    },
    {
      "year": 2018,
      "value": 2.25
    },
    {
      "year": 2019,
      "value": 2.4
    },
    {
      "year": 2020,
      "value": 2.45
    },
    {
      "year": 2021,
      "value": 2.7
    },
    {
      "year": 2022,
      "value": 3.3
    },
    {
      "year": 2023,
      "value": 4.5
    },
    {
      "year": 2024,
      "value": 4.7
    },
    {
      "year": 2025,
      "value": 5.1
    }
  ],
  "atlanta-hawks": [
    {
      "year": 2016,
      "value": 0.885
    },
    {
      "year": 2017,
      "value": 1.15
    },
    {
      "year": 2018,
      "value": 1.3
    },
    {
      "year": 2019,
      "value": 1.52
    },
    {
      "year": 2020,
      "value": 1.52
    },
    {
      "year": 2021,
      "value": 1.68
    },
    {
      "year": 2022,
      "value": 1.975
    },
    {
      "year": 2023,
      "value": 3.325
    },
    {
      "year": 2024,
      "value": 3.8
    },
    {
      "year": 2025,
      "value": 5
    }
  ],
  "cleveland-cavaliers": [
    {
      "year": 2016,
      "value": 1.2
    },
    {
      "year": 2017,
      "value": 1.325
    },
    {
      "year": 2018,
      "value": 1.275
    },
    {
      "year": 2019,
      "value": 1.51
    },
    {
      "year": 2020,
      "value": 1.56
    },
    {
      "year": 2021,
      "value": 1.65
    },
    {
      "year": 2022,
      "value": 2.05
    },
    {
      "year": 2023,
      "value": 3.35
    },
    {
      "year": 2024,
      "value": 3.95
    },
    {
      "year": 2025,
      "value": 4.8
    }
  ],
  "washington-wizards": [
    {
      "year": 2016,
      "value": 1
    },
    {
      "year": 2017,
      "value": 1.35
    },
    {
      "year": 2018,
      "value": 1.55
    },
    {
      "year": 2019,
      "value": 1.75
    },
    {
      "year": 2020,
      "value": 1.8
    },
    {
      "year": 2021,
      "value": 1.925
    },
    {
      "year": 2022,
      "value": 2.5
    },
    {
      "year": 2023,
      "value": 3.5
    },
    {
      "year": 2024,
      "value": 4.1
    },
    {
      "year": 2025,
      "value": 4.7
    }
  ],
  "denver-nuggets": [
    {
      "year": 2016,
      "value": 0.89
    },
    {
      "year": 2017,
      "value": 1.125
    },
    {
      "year": 2018,
      "value": 1.375
    },
    {
      "year": 2019,
      "value": 1.6
    },
    {
      "year": 2020,
      "value": 1.65
    },
    {
      "year": 2021,
      "value": 1.725
    },
    {
      "year": 2022,
      "value": 1.93
    },
    {
      "year": 2023,
      "value": 3.375
    },
    {
      "year": 2024,
      "value": 3.9
    },
    {
      "year": 2025,
      "value": 4.6
    }
  ],
  "sacramento-kings": [
    {
      "year": 2016,
      "value": 1.075
    },
    {
      "year": 2017,
      "value": 1.375
    },
    {
      "year": 2018,
      "value": 1.575
    },
    {
      "year": 2019,
      "value": 1.775
    },
    {
      "year": 2020,
      "value": 1.825
    },
    {
      "year": 2021,
      "value": 2
    },
    {
      "year": 2022,
      "value": 2.03
    },
    {
      "year": 2023,
      "value": 3.33
    },
    {
      "year": 2024,
      "value": 3.7
    },
    {
      "year": 2025,
      "value": 4.45
    }
  ],
  "san-antonio-spurs": [
    {
      "year": 2016,
      "value": 1.175
    },
    {
      "year": 2017,
      "value": 1.55
    },
    {
      "year": 2018,
      "value": 1.625
    },
    {
      "year": 2019,
      "value": 1.8
    },
    {
      "year": 2020,
      "value": 1.85
    },
    {
      "year": 2021,
      "value": 1.98
    },
    {
      "year": 2022,
      "value": 2
    },
    {
      "year": 2023,
      "value": 3.25
    },
    {
      "year": 2024,
      "value": 3.85
    },
    {
      "year": 2025,
      "value": 4.4
    }
  ],
  "oklahoma-city-thunder": [
    {
      "year": 2016,
      "value": 1.025
    },
    {
      "year": 2017,
      "value": 1.25
    },
    {
      "year": 2018,
      "value": 1.475
    },
    {
      "year": 2019,
      "value": 1.575
    },
    {
      "year": 2020,
      "value": 1.575
    },
    {
      "year": 2021,
      "value": 1.63
    },
    {
      "year": 2022,
      "value": 1.875
    },
    {
      "year": 2023,
      "value": 3.05
    },
    {
      "year": 2024,
      "value": 3.65
    },
    {
      "year": 2025,
      "value": 4.35
    }
  ],
  "milwaukee-bucks": [
    {
      "year": 2016,
      "value": 0.785
    },
    {
      "year": 2017,
      "value": 1.075
    },
    {
      "year": 2018,
      "value": 1.35
    },
    {
      "year": 2019,
      "value": 1.58
    },
    {
      "year": 2020,
      "value": 1.625
    },
    {
      "year": 2021,
      "value": 1.9
    },
    {
      "year": 2022,
      "value": 2.3
    },
    {
      "year": 2023,
      "value": 3.2
    },
    {
      "year": 2024,
      "value": 4
    },
    {
      "year": 2025,
      "value": 4.3
    }
  ],
  "portland-trail-blazers": [
    {
      "year": 2016,
      "value": 1.05
    },
    {
      "year": 2017,
      "value": 1.3
    },
    {
      "year": 2018,
      "value": 1.6
    },
    {
      "year": 2019,
      "value": 1.85
    },
    {
      "year": 2020,
      "value": 1.9
    },
    {
      "year": 2021,
      "value": 2.05
    },
    {
      "year": 2022,
      "value": 2.1
    },
    {
      "year": 2023,
      "value": 3.08
    },
    {
      "year": 2024,
      "value": 3.5
    },
    {
      "year": 2025,
      "value": 4.25
    }
  ],
  "indiana-pacers": [
    {
      "year": 2016,
      "value": 0.88
    },
    {
      "year": 2017,
      "value": 1.175
    },
    {
      "year": 2018,
      "value": 1.4
    },
    {
      "year": 2019,
      "value": 1.525
    },
    {
      "year": 2020,
      "value": 1.55
    },
    {
      "year": 2021,
      "value": 1.67
    },
    {
      "year": 2022,
      "value": 1.8
    },
    {
      "year": 2023,
      "value": 2.9
    },
    {
      "year": 2024,
      "value": 3.6
    },
    {
      "year": 2025,
      "value": 4.2
    }
  ],
  "utah-jazz": [
    {
      "year": 2016,
      "value": 0.91
    },
    {
      "year": 2017,
      "value": 1.2
    },
    {
      "year": 2018,
      "value": 1.425
    },
    {
      "year": 2019,
      "value": 1.55
    },
    {
      "year": 2020,
      "value": 1.66
    },
    {
      "year": 2021,
      "value": 1.75
    },
    {
      "year": 2022,
      "value": 2.025
    },
    {
      "year": 2023,
      "value": 3.09
    },
    {
      "year": 2024,
      "value": 3.55
    },
    {
      "year": 2025,
      "value": 4.1
    }
  ],
  "orlando-magic": [
    {
      "year": 2016,
      "value": 0.92
    },
    {
      "year": 2017,
      "value": 1.225
    },
    {
      "year": 2018,
      "value": 1.325
    },
    {
      "year": 2019,
      "value": 1.43
    },
    {
      "year": 2020,
      "value": 1.46
    },
    {
      "year": 2021,
      "value": 1.64
    },
    {
      "year": 2022,
      "value": 1.85
    },
    {
      "year": 2023,
      "value": 2.95
    },
    {
      "year": 2024,
      "value": 3.2
    },
    {
      "year": 2025,
      "value": 3.9
    }
  ],
  "charlotte-hornets": [
    {
      "year": 2016,
      "value": 0.78
    },
    {
      "year": 2017,
      "value": 1.05
    },
    {
      "year": 2018,
      "value": 1.25
    },
    {
      "year": 2019,
      "value": 1.5
    },
    {
      "year": 2020,
      "value": 1.5
    },
    {
      "year": 2021,
      "value": 1.575
    },
    {
      "year": 2022,
      "value": 1.7
    },
    {
      "year": 2023,
      "value": 3
    },
    {
      "year": 2024,
      "value": 3.3
    },
    {
      "year": 2025,
      "value": 3.8
    }
  ],
  "detroit-pistons": [
    {
      "year": 2016,
      "value": 0.9
    },
    {
      "year": 2017,
      "value": 1.1
    },
    {
      "year": 2018,
      "value": 1.27
    },
    {
      "year": 2019,
      "value": 1.45
    },
    {
      "year": 2020,
      "value": 1.45
    },
    {
      "year": 2021,
      "value": 1.58
    },
    {
      "year": 2022,
      "value": 1.9
    },
    {
      "year": 2023,
      "value": 3.075
    },
    {
      "year": 2024,
      "value": 3.4
    },
    {
      "year": 2025,
      "value": 3.65
    }
  ],
  "minnesota-timberwolves": [
    {
      "year": 2016,
      "value": 0.77
    },
    {
      "year": 2017,
      "value": 1.06
    },
    {
      "year": 2018,
      "value": 1.26
    },
    {
      "year": 2019,
      "value": 1.375
    },
    {
      "year": 2020,
      "value": 1.4
    },
    {
      "year": 2021,
      "value": 1.55
    },
    {
      "year": 2022,
      "value": 1.67
    },
    {
      "year": 2023,
      "value": 2.5
    },
    {
      "year": 2024,
      "value": 3.1
    },
    {
      "year": 2025,
      "value": 3.6
    }
  ],
  "new-orleans-pelicans": [
    {
      "year": 2016,
      "value": 0.75
    },
    {
      "year": 2017,
      "value": 1
    },
    {
      "year": 2018,
      "value": 1.22
    },
    {
      "year": 2019,
      "value": 1.35
    },
    {
      "year": 2020,
      "value": 1.35
    },
    {
      "year": 2021,
      "value": 1.525
    },
    {
      "year": 2022,
      "value": 1.6
    },
    {
      "year": 2023,
      "value": 2.55
    },
    {
      "year": 2024,
      "value": 3.05
    },
    {
      "year": 2025,
      "value": 3.55
    }
  ],
  "memphis-grizzlies": [
    {
      "year": 2016,
      "value": 0.79
    },
    {
      "year": 2017,
      "value": 1.025
    },
    {
      "year": 2018,
      "value": 1.2
    },
    {
      "year": 2019,
      "value": 1.3
    },
    {
      "year": 2020,
      "value": 1.3
    },
    {
      "year": 2021,
      "value": 1.5
    },
    {
      "year": 2022,
      "value": 1.65
    },
    {
      "year": 2023,
      "value": 2.4
    },
    {
      "year": 2024,
      "value": 3
    },
    {
      "year": 2025,
      "value": 3.5
    }
  ],
  "dallas-cowboys": [
    {
      "year": 2017,
      "value": 4.8
    },
    {
      "year": 2018,
      "value": 5
    },
    {
      "year": 2019,
      "value": 5.5
    },
    {
      "year": 2020,
      "value": 5.7
    },
    {
      "year": 2021,
      "value": 6.5
    },
    {
      "year": 2022,
      "value": 8
    },
    {
      "year": 2023,
      "value": 9
    },
    {
      "year": 2024,
      "value": 10.1
    },
    {
      "year": 2025,
      "value": 13
    },
    {
      "year": 2026,
      "value": 17
    }
  ],
  "los-angeles-rams": [
    {
      "year": 2017,
      "value": 3
    },
    {
      "year": 2018,
      "value": 3.2
    },
    {
      "year": 2019,
      "value": 3.8
    },
    {
      "year": 2020,
      "value": 4
    },
    {
      "year": 2021,
      "value": 4.8
    },
    {
      "year": 2022,
      "value": 6.2
    },
    {
      "year": 2023,
      "value": 6.9
    },
    {
      "year": 2024,
      "value": 7.6
    },
    {
      "year": 2025,
      "value": 10.5
    },
    {
      "year": 2026,
      "value": 13.5
    }
  ],
  "new-york-giants": [
    {
      "year": 2017,
      "value": 3.3
    },
    {
      "year": 2018,
      "value": 3.3
    },
    {
      "year": 2019,
      "value": 3.9
    },
    {
      "year": 2020,
      "value": 4.3
    },
    {
      "year": 2021,
      "value": 4.85
    },
    {
      "year": 2022,
      "value": 6
    },
    {
      "year": 2023,
      "value": 6.8
    },
    {
      "year": 2024,
      "value": 7.3
    },
    {
      "year": 2025,
      "value": 10.1
    },
    {
      "year": 2026,
      "value": 12
    }
  ],
  "new-england-patriots": [
    {
      "year": 2017,
      "value": 3.7
    },
    {
      "year": 2018,
      "value": 3.8
    },
    {
      "year": 2019,
      "value": 4.1
    },
    {
      "year": 2020,
      "value": 4.4
    },
    {
      "year": 2021,
      "value": 5
    },
    {
      "year": 2022,
      "value": 6.4
    },
    {
      "year": 2023,
      "value": 7
    },
    {
      "year": 2024,
      "value": 7.4
    },
    {
      "year": 2025,
      "value": 9
    },
    {
      "year": 2026,
      "value": 10.6
    }
  ],
  "san-francisco-49ers": [
    {
      "year": 2017,
      "value": 3.05
    },
    {
      "year": 2018,
      "value": 3.05
    },
    {
      "year": 2019,
      "value": 3.5
    },
    {
      "year": 2020,
      "value": 3.8
    },
    {
      "year": 2021,
      "value": 4.175
    },
    {
      "year": 2022,
      "value": 5.2
    },
    {
      "year": 2023,
      "value": 6
    },
    {
      "year": 2024,
      "value": 6.8
    },
    {
      "year": 2025,
      "value": 8.6
    },
    {
      "year": 2026,
      "value": 10.5
    }
  ],
  "miami-dolphins": [
    {
      "year": 2017,
      "value": 2.575
    },
    {
      "year": 2018,
      "value": 2.575
    },
    {
      "year": 2019,
      "value": 2.76
    },
    {
      "year": 2020,
      "value": 2.9
    },
    {
      "year": 2021,
      "value": 3.42
    },
    {
      "year": 2022,
      "value": 4.6
    },
    {
      "year": 2023,
      "value": 5.7
    },
    {
      "year": 2024,
      "value": 6.2
    },
    {
      "year": 2025,
      "value": 7.5
    },
    {
      "year": 2026,
      "value": 10.4
    }
  ],
  "new-york-jets": [
    {
      "year": 2017,
      "value": 2.75
    },
    {
      "year": 2018,
      "value": 2.85
    },
    {
      "year": 2019,
      "value": 3.2
    },
    {
      "year": 2020,
      "value": 3.55
    },
    {
      "year": 2021,
      "value": 4.05
    },
    {
      "year": 2022,
      "value": 5.4
    },
    {
      "year": 2023,
      "value": 6.1
    },
    {
      "year": 2024,
      "value": 6.9
    },
    {
      "year": 2025,
      "value": 8.1
    },
    {
      "year": 2026,
      "value": 10.35
    }
  ],
  "las-vegas-raiders": [
    {
      "year": 2017,
      "value": 2.38
    },
    {
      "year": 2018,
      "value": 2.42
    },
    {
      "year": 2019,
      "value": 2.9
    },
    {
      "year": 2020,
      "value": 3.1
    },
    {
      "year": 2021,
      "value": 3.415
    },
    {
      "year": 2022,
      "value": 5.1
    },
    {
      "year": 2023,
      "value": 6.2
    },
    {
      "year": 2024,
      "value": 6.7
    },
    {
      "year": 2025,
      "value": 7.7
    },
    {
      "year": 2026,
      "value": 10.3
    }
  ],
  "philadelphia-eagles": [
    {
      "year": 2017,
      "value": 2.65
    },
    {
      "year": 2018,
      "value": 2.75
    },
    {
      "year": 2019,
      "value": 3.05
    },
    {
      "year": 2020,
      "value": 3.4
    },
    {
      "year": 2021,
      "value": 3.8
    },
    {
      "year": 2022,
      "value": 4.9
    },
    {
      "year": 2023,
      "value": 5.8
    },
    {
      "year": 2024,
      "value": 6.6
    },
    {
      "year": 2025,
      "value": 8.3
    },
    {
      "year": 2026,
      "value": 10.25
    }
  ],
  "atlanta-falcons": [
    {
      "year": 2017,
      "value": 2.475
    },
    {
      "year": 2018,
      "value": 2.6
    },
    {
      "year": 2019,
      "value": 2.755
    },
    {
      "year": 2020,
      "value": 2.875
    },
    {
      "year": 2021,
      "value": 3.2
    },
    {
      "year": 2022,
      "value": 4
    },
    {
      "year": 2023,
      "value": 4.7
    },
    {
      "year": 2024,
      "value": 5.2
    },
    {
      "year": 2025,
      "value": 6.35
    },
    {
      "year": 2026,
      "value": 10.1
    }
  ],
  "washington-commanders": [
    {
      "year": 2017,
      "value": 3.1
    },
    {
      "year": 2018,
      "value": 3.1
    },
    {
      "year": 2019,
      "value": 3.4
    },
    {
      "year": 2020,
      "value": 3.5
    },
    {
      "year": 2021,
      "value": 4.2
    },
    {
      "year": 2022,
      "value": 5.6
    },
    {
      "year": 2023,
      "value": 6.05
    },
    {
      "year": 2024,
      "value": 6.3
    },
    {
      "year": 2025,
      "value": 7.6
    },
    {
      "year": 2026,
      "value": 9.8
    }
  ],
  "chicago-bears": [
    {
      "year": 2017,
      "value": 2.85
    },
    {
      "year": 2018,
      "value": 2.9
    },
    {
      "year": 2019,
      "value": 3.45
    },
    {
      "year": 2020,
      "value": 3.525
    },
    {
      "year": 2021,
      "value": 4.075
    },
    {
      "year": 2022,
      "value": 5.8
    },
    {
      "year": 2023,
      "value": 6.3
    },
    {
      "year": 2024,
      "value": 6.4
    },
    {
      "year": 2025,
      "value": 8.2
    },
    {
      "year": 2026,
      "value": 9.7
    }
  ],
  "houston-texans": [
    {
      "year": 2017,
      "value": 2.8
    },
    {
      "year": 2018,
      "value": 2.8
    },
    {
      "year": 2019,
      "value": 3.1
    },
    {
      "year": 2020,
      "value": 3.3
    },
    {
      "year": 2021,
      "value": 3.7
    },
    {
      "year": 2022,
      "value": 4.7
    },
    {
      "year": 2023,
      "value": 5.5
    },
    {
      "year": 2024,
      "value": 6.1
    },
    {
      "year": 2025,
      "value": 7.4
    },
    {
      "year": 2026,
      "value": 9.65
    }
  ],
  "seattle-seahawks": [
    {
      "year": 2017,
      "value": 2.425
    },
    {
      "year": 2018,
      "value": 2.58
    },
    {
      "year": 2019,
      "value": 2.775
    },
    {
      "year": 2020,
      "value": 3.075
    },
    {
      "year": 2021,
      "value": 3.5
    },
    {
      "year": 2022,
      "value": 4.5
    },
    {
      "year": 2023,
      "value": 5
    },
    {
      "year": 2024,
      "value": 5.45
    },
    {
      "year": 2025,
      "value": 6.7
    },
    {
      "year": 2026,
      "value": 9.6
    }
  ],
  "denver-broncos": [
    {
      "year": 2017,
      "value": 2.6
    },
    {
      "year": 2018,
      "value": 2.65
    },
    {
      "year": 2019,
      "value": 3
    },
    {
      "year": 2020,
      "value": 3.2
    },
    {
      "year": 2021,
      "value": 3.75
    },
    {
      "year": 2022,
      "value": 4.65
    },
    {
      "year": 2023,
      "value": 5.1
    },
    {
      "year": 2024,
      "value": 5.5
    },
    {
      "year": 2025,
      "value": 6.8
    },
    {
      "year": 2026,
      "value": 9.4
    }
  ],
  "tampa-bay-buccaneers": [
    {
      "year": 2017,
      "value": 1.975
    },
    {
      "year": 2018,
      "value": 2
    },
    {
      "year": 2019,
      "value": 2.2
    },
    {
      "year": 2020,
      "value": 2.28
    },
    {
      "year": 2021,
      "value": 2.94
    },
    {
      "year": 2022,
      "value": 3.675
    },
    {
      "year": 2023,
      "value": 4.2
    },
    {
      "year": 2024,
      "value": 5.4
    },
    {
      "year": 2025,
      "value": 6.6
    },
    {
      "year": 2026,
      "value": 9.1
    }
  ],
  "cleveland-browns": [
    {
      "year": 2017,
      "value": 1.95
    },
    {
      "year": 2018,
      "value": 1.95
    },
    {
      "year": 2019,
      "value": 2.175
    },
    {
      "year": 2020,
      "value": 2.35
    },
    {
      "year": 2021,
      "value": 2.6
    },
    {
      "year": 2022,
      "value": 3.85
    },
    {
      "year": 2023,
      "value": 4.62
    },
    {
      "year": 2024,
      "value": 5.15
    },
    {
      "year": 2025,
      "value": 6.4
    },
    {
      "year": 2026,
      "value": 9
    }
  ],
  "kansas-city-chiefs": [
    {
      "year": 2017,
      "value": 2.1
    },
    {
      "year": 2018,
      "value": 2.1
    },
    {
      "year": 2019,
      "value": 2.3
    },
    {
      "year": 2020,
      "value": 2.5
    },
    {
      "year": 2021,
      "value": 2.93
    },
    {
      "year": 2022,
      "value": 3.7
    },
    {
      "year": 2023,
      "value": 4.3
    },
    {
      "year": 2024,
      "value": 4.85
    },
    {
      "year": 2025,
      "value": 6.2
    },
    {
      "year": 2026,
      "value": 8.8
    }
  ],
  "pittsburgh-steelers": [
    {
      "year": 2017,
      "value": 2.45
    },
    {
      "year": 2018,
      "value": 2.585
    },
    {
      "year": 2019,
      "value": 2.8
    },
    {
      "year": 2020,
      "value": 3
    },
    {
      "year": 2021,
      "value": 3.43
    },
    {
      "year": 2022,
      "value": 3.975
    },
    {
      "year": 2023,
      "value": 4.625
    },
    {
      "year": 2024,
      "value": 5.3
    },
    {
      "year": 2025,
      "value": 6.5
    },
    {
      "year": 2026,
      "value": 8.7
    }
  ],
  "green-bay-packers": [
    {
      "year": 2017,
      "value": 2.55
    },
    {
      "year": 2018,
      "value": 2.625
    },
    {
      "year": 2019,
      "value": 2.85
    },
    {
      "year": 2020,
      "value": 3.05
    },
    {
      "year": 2021,
      "value": 3.475
    },
    {
      "year": 2022,
      "value": 4.25
    },
    {
      "year": 2023,
      "value": 4.6
    },
    {
      "year": 2024,
      "value": 5.6
    },
    {
      "year": 2025,
      "value": 6.65
    },
    {
      "year": 2026,
      "value": 8.6
    }
  ],
  "tennessee-titans": [
    {
      "year": 2017,
      "value": 2.05
    },
    {
      "year": 2018,
      "value": 2.05
    },
    {
      "year": 2019,
      "value": 2.15
    },
    {
      "year": 2020,
      "value": 2.3
    },
    {
      "year": 2021,
      "value": 2.625
    },
    {
      "year": 2022,
      "value": 3.5
    },
    {
      "year": 2023,
      "value": 4.4
    },
    {
      "year": 2024,
      "value": 4.9
    },
    {
      "year": 2025,
      "value": 6.3
    },
    {
      "year": 2026,
      "value": 8.5
    }
  ],
  "los-angeles-chargers": [
    {
      "year": 2017,
      "value": 2.275
    },
    {
      "year": 2018,
      "value": 2.275
    },
    {
      "year": 2019,
      "value": 2.5
    },
    {
      "year": 2020,
      "value": 2.6
    },
    {
      "year": 2021,
      "value": 2.92
    },
    {
      "year": 2022,
      "value": 3.875
    },
    {
      "year": 2023,
      "value": 4.15
    },
    {
      "year": 2024,
      "value": 5.1
    },
    {
      "year": 2025,
      "value": 6
    },
    {
      "year": 2026,
      "value": 8.3
    }
  ],
  "minnesota-vikings": [
    {
      "year": 2017,
      "value": 2.4
    },
    {
      "year": 2018,
      "value": 2.4
    },
    {
      "year": 2019,
      "value": 2.7
    },
    {
      "year": 2020,
      "value": 2.95
    },
    {
      "year": 2021,
      "value": 3.35
    },
    {
      "year": 2022,
      "value": 3.925
    },
    {
      "year": 2023,
      "value": 4.65
    },
    {
      "year": 2024,
      "value": 5.05
    },
    {
      "year": 2025,
      "value": 6.25
    },
    {
      "year": 2026,
      "value": 8.25
    }
  ],
  "baltimore-ravens": [
    {
      "year": 2017,
      "value": 2.5
    },
    {
      "year": 2018,
      "value": 2.59
    },
    {
      "year": 2019,
      "value": 2.75
    },
    {
      "year": 2020,
      "value": 2.975
    },
    {
      "year": 2021,
      "value": 3.4
    },
    {
      "year": 2022,
      "value": 3.9
    },
    {
      "year": 2023,
      "value": 4.63
    },
    {
      "year": 2024,
      "value": 5
    },
    {
      "year": 2025,
      "value": 6.1
    },
    {
      "year": 2026,
      "value": 8.2
    }
  ],
  "buffalo-bills": [
    {
      "year": 2017,
      "value": 1.6
    },
    {
      "year": 2018,
      "value": 1.6
    },
    {
      "year": 2019,
      "value": 1.9
    },
    {
      "year": 2020,
      "value": 2.05
    },
    {
      "year": 2021,
      "value": 2.27
    },
    {
      "year": 2022,
      "value": 3.4
    },
    {
      "year": 2023,
      "value": 3.7
    },
    {
      "year": 2024,
      "value": 4.2
    },
    {
      "year": 2025,
      "value": 5.95
    },
    {
      "year": 2026,
      "value": 8.15
    }
  ],
  "carolina-panthers": [
    {
      "year": 2017,
      "value": 2.3
    },
    {
      "year": 2018,
      "value": 2.3
    },
    {
      "year": 2019,
      "value": 2.4
    },
    {
      "year": 2020,
      "value": 2.55
    },
    {
      "year": 2021,
      "value": 2.91
    },
    {
      "year": 2022,
      "value": 3.6
    },
    {
      "year": 2023,
      "value": 4.1
    },
    {
      "year": 2024,
      "value": 4.5
    },
    {
      "year": 2025,
      "value": 5.7
    },
    {
      "year": 2026,
      "value": 8.1
    }
  ],
  "indianapolis-colts": [
    {
      "year": 2017,
      "value": 2.375
    },
    {
      "year": 2018,
      "value": 2.38
    },
    {
      "year": 2019,
      "value": 2.65
    },
    {
      "year": 2020,
      "value": 2.85
    },
    {
      "year": 2021,
      "value": 3.25
    },
    {
      "year": 2022,
      "value": 3.8
    },
    {
      "year": 2023,
      "value": 4.35
    },
    {
      "year": 2024,
      "value": 4.8
    },
    {
      "year": 2025,
      "value": 5.9
    },
    {
      "year": 2026,
      "value": 8.08
    }
  ],
  "arizona-cardinals": [
    {
      "year": 2017,
      "value": 2.15
    },
    {
      "year": 2018,
      "value": 2.15
    },
    {
      "year": 2019,
      "value": 2.25
    },
    {
      "year": 2020,
      "value": 2.325
    },
    {
      "year": 2021,
      "value": 2.65
    },
    {
      "year": 2022,
      "value": 3.27
    },
    {
      "year": 2023,
      "value": 3.8
    },
    {
      "year": 2024,
      "value": 4.3
    },
    {
      "year": 2025,
      "value": 5.5
    },
    {
      "year": 2026,
      "value": 8.06
    }
  ],
  "jacksonville-jaguars": [
    {
      "year": 2017,
      "value": 2.075
    },
    {
      "year": 2018,
      "value": 2.08
    },
    {
      "year": 2019,
      "value": 2.325
    },
    {
      "year": 2020,
      "value": 2.45
    },
    {
      "year": 2021,
      "value": 2.8
    },
    {
      "year": 2022,
      "value": 3.475
    },
    {
      "year": 2023,
      "value": 4
    },
    {
      "year": 2024,
      "value": 4.6
    },
    {
      "year": 2025,
      "value": 5.6
    },
    {
      "year": 2026,
      "value": 8.05
    }
  ],
  "detroit-lions": [
    {
      "year": 2017,
      "value": 1.7
    },
    {
      "year": 2018,
      "value": 1.7
    },
    {
      "year": 2019,
      "value": 1.95
    },
    {
      "year": 2020,
      "value": 2.1
    },
    {
      "year": 2021,
      "value": 2.4
    },
    {
      "year": 2022,
      "value": 3.05
    },
    {
      "year": 2023,
      "value": 3.6
    },
    {
      "year": 2024,
      "value": 4.15
    },
    {
      "year": 2025,
      "value": 5.4
    },
    {
      "year": 2026,
      "value": 8.04
    }
  ],
  "new-orleans-saints": [
    {
      "year": 2017,
      "value": 2
    },
    {
      "year": 2018,
      "value": 2.075
    },
    {
      "year": 2019,
      "value": 2.275
    },
    {
      "year": 2020,
      "value": 2.475
    },
    {
      "year": 2021,
      "value": 2.825
    },
    {
      "year": 2022,
      "value": 3.575
    },
    {
      "year": 2023,
      "value": 4.075
    },
    {
      "year": 2024,
      "value": 4.4
    },
    {
      "year": 2025,
      "value": 5.3
    },
    {
      "year": 2026,
      "value": 8.02
    }
  ],
  "cincinnati-bengals": [
    {
      "year": 2017,
      "value": 1.8
    },
    {
      "year": 2018,
      "value": 1.8
    },
    {
      "year": 2019,
      "value": 2
    },
    {
      "year": 2020,
      "value": 2
    },
    {
      "year": 2021,
      "value": 2.275
    },
    {
      "year": 2022,
      "value": 3
    },
    {
      "year": 2023,
      "value": 3.5
    },
    {
      "year": 2024,
      "value": 4.1
    },
    {
      "year": 2025,
      "value": 5.25
    },
    {
      "year": 2026,
      "value": 8
    }
  ],
  "toronto-maple-leafs": [
    {
      "year": 2015,
      "value": 1.15
    },
    {
      "year": 2016,
      "value": 1.1
    },
    {
      "year": 2017,
      "value": 1.4
    },
    {
      "year": 2018,
      "value": 1.45
    },
    {
      "year": 2019,
      "value": 1.5
    },
    {
      "year": 2020,
      "value": 1.5
    },
    {
      "year": 2021,
      "value": 1.8
    },
    {
      "year": 2022,
      "value": 2
    },
    {
      "year": 2023,
      "value": 2.8
    },
    {
      "year": 2024,
      "value": 3.8
    }
  ],
  "new-york-rangers": [
    {
      "year": 2015,
      "value": 1.2
    },
    {
      "year": 2016,
      "value": 1.25
    },
    {
      "year": 2017,
      "value": 1.5
    },
    {
      "year": 2018,
      "value": 1.55
    },
    {
      "year": 2019,
      "value": 1.65
    },
    {
      "year": 2020,
      "value": 1.65
    },
    {
      "year": 2021,
      "value": 2
    },
    {
      "year": 2022,
      "value": 2.2
    },
    {
      "year": 2023,
      "value": 2.65
    },
    {
      "year": 2024,
      "value": 3.5
    }
  ],
  "montreal-canadiens": [
    {
      "year": 2015,
      "value": 1.175
    },
    {
      "year": 2016,
      "value": 1.12
    },
    {
      "year": 2017,
      "value": 1.25
    },
    {
      "year": 2018,
      "value": 1.3
    },
    {
      "year": 2019,
      "value": 1.34
    },
    {
      "year": 2020,
      "value": 1.34
    },
    {
      "year": 2021,
      "value": 1.6
    },
    {
      "year": 2022,
      "value": 1.85
    },
    {
      "year": 2023,
      "value": 2.3
    },
    {
      "year": 2024,
      "value": 3
    }
  ],
  "los-angeles-kings": [
    {
      "year": 2015,
      "value": 0.58
    },
    {
      "year": 2016,
      "value": 0.6
    },
    {
      "year": 2017,
      "value": 0.75
    },
    {
      "year": 2018,
      "value": 0.81
    },
    {
      "year": 2019,
      "value": 0.85
    },
    {
      "year": 2020,
      "value": 0.825
    },
    {
      "year": 2021,
      "value": 1.025
    },
    {
      "year": 2022,
      "value": 1.3
    },
    {
      "year": 2023,
      "value": 2
    },
    {
      "year": 2024,
      "value": 2.9
    }
  ],
  "boston-bruins": [
    {
      "year": 2015,
      "value": 0.75
    },
    {
      "year": 2016,
      "value": 0.8
    },
    {
      "year": 2017,
      "value": 0.89
    },
    {
      "year": 2018,
      "value": 0.925
    },
    {
      "year": 2019,
      "value": 1
    },
    {
      "year": 2020,
      "value": 1
    },
    {
      "year": 2021,
      "value": 1.3
    },
    {
      "year": 2022,
      "value": 1.4
    },
    {
      "year": 2023,
      "value": 1.9
    },
    {
      "year": 2024,
      "value": 2.7
    }
  ],
  "edmonton-oilers": [
    {
      "year": 2015,
      "value": 0.455
    },
    {
      "year": 2016,
      "value": 0.445
    },
    {
      "year": 2017,
      "value": 0.52
    },
    {
      "year": 2018,
      "value": 0.54
    },
    {
      "year": 2019,
      "value": 0.575
    },
    {
      "year": 2020,
      "value": 0.55
    },
    {
      "year": 2021,
      "value": 1.1
    },
    {
      "year": 2022,
      "value": 1.275
    },
    {
      "year": 2023,
      "value": 1.85
    },
    {
      "year": 2024,
      "value": 2.65
    }
  ],
  "chicago-blackhawks": [
    {
      "year": 2015,
      "value": 0.925
    },
    {
      "year": 2016,
      "value": 0.925
    },
    {
      "year": 2017,
      "value": 1
    },
    {
      "year": 2018,
      "value": 1.05
    },
    {
      "year": 2019,
      "value": 1.085
    },
    {
      "year": 2020,
      "value": 1.085
    },
    {
      "year": 2021,
      "value": 1.4
    },
    {
      "year": 2022,
      "value": 1.5
    },
    {
      "year": 2023,
      "value": 1.875
    },
    {
      "year": 2024,
      "value": 2.45
    }
  ],
  "philadelphia-flyers": [
    {
      "year": 2015,
      "value": 0.66
    },
    {
      "year": 2016,
      "value": 0.72
    },
    {
      "year": 2017,
      "value": 0.74
    },
    {
      "year": 2018,
      "value": 0.8
    },
    {
      "year": 2019,
      "value": 0.825
    },
    {
      "year": 2020,
      "value": 0.8
    },
    {
      "year": 2021,
      "value": 1.2
    },
    {
      "year": 2022,
      "value": 1.25
    },
    {
      "year": 2023,
      "value": 1.65
    },
    {
      "year": 2024,
      "value": 2.3
    }
  ],
  "washington-capitals": [
    {
      "year": 2015,
      "value": 0.565
    },
    {
      "year": 2016,
      "value": 0.575
    },
    {
      "year": 2017,
      "value": 0.625
    },
    {
      "year": 2018,
      "value": 0.725
    },
    {
      "year": 2019,
      "value": 0.775
    },
    {
      "year": 2020,
      "value": 0.75
    },
    {
      "year": 2021,
      "value": 0.93
    },
    {
      "year": 2022,
      "value": 1.2
    },
    {
      "year": 2023,
      "value": 1.6
    },
    {
      "year": 2024,
      "value": 2.15
    }
  ],
  "detroit-red-wings": [
    {
      "year": 2015,
      "value": 0.6
    },
    {
      "year": 2016,
      "value": 0.625
    },
    {
      "year": 2017,
      "value": 0.7
    },
    {
      "year": 2018,
      "value": 0.775
    },
    {
      "year": 2019,
      "value": 0.8
    },
    {
      "year": 2020,
      "value": 0.775
    },
    {
      "year": 2021,
      "value": 0.99
    },
    {
      "year": 2022,
      "value": 1.03
    },
    {
      "year": 2023,
      "value": 1.2
    },
    {
      "year": 2024,
      "value": 2.125
    }
  ],
  "new-jersey-devils": [
    {
      "year": 2015,
      "value": 0.33
    },
    {
      "year": 2016,
      "value": 0.32
    },
    {
      "year": 2017,
      "value": 0.4
    },
    {
      "year": 2018,
      "value": 0.455
    },
    {
      "year": 2019,
      "value": 0.55
    },
    {
      "year": 2020,
      "value": 0.53
    },
    {
      "year": 2021,
      "value": 0.775
    },
    {
      "year": 2022,
      "value": 0.96
    },
    {
      "year": 2023,
      "value": 1.45
    },
    {
      "year": 2024,
      "value": 2.1
    }
  ],
  "dallas-stars": [
    {
      "year": 2015,
      "value": 0.45
    },
    {
      "year": 2016,
      "value": 0.5
    },
    {
      "year": 2017,
      "value": 0.515
    },
    {
      "year": 2018,
      "value": 0.525
    },
    {
      "year": 2019,
      "value": 0.6
    },
    {
      "year": 2020,
      "value": 0.575
    },
    {
      "year": 2021,
      "value": 0.72
    },
    {
      "year": 2022,
      "value": 0.925
    },
    {
      "year": 2023,
      "value": 1.08
    },
    {
      "year": 2024,
      "value": 2
    }
  ],
  "vancouver-canucks": [
    {
      "year": 2015,
      "value": 0.745
    },
    {
      "year": 2016,
      "value": 0.7
    },
    {
      "year": 2017,
      "value": 0.73
    },
    {
      "year": 2018,
      "value": 0.735
    },
    {
      "year": 2019,
      "value": 0.74
    },
    {
      "year": 2020,
      "value": 0.725
    },
    {
      "year": 2021,
      "value": 0.825
    },
    {
      "year": 2022,
      "value": 1.01
    },
    {
      "year": 2023,
      "value": 1.325
    },
    {
      "year": 2024,
      "value": 1.95
    }
  ],
  "new-york-islanders": [
    {
      "year": 2015,
      "value": 0.325
    },
    {
      "year": 2016,
      "value": 0.385
    },
    {
      "year": 2017,
      "value": 0.395
    },
    {
      "year": 2018,
      "value": 0.44
    },
    {
      "year": 2019,
      "value": 0.52
    },
    {
      "year": 2020,
      "value": 0.52
    },
    {
      "year": 2021,
      "value": 0.95
    },
    {
      "year": 2022,
      "value": 1.02
    },
    {
      "year": 2023,
      "value": 1.55
    },
    {
      "year": 2024,
      "value": 1.9
    }
  ],
  "vegas-golden-knights": [
    {
      "year": 2017,
      "value": 0.5
    },
    {
      "year": 2018,
      "value": 0.575
    },
    {
      "year": 2019,
      "value": 0.58
    },
    {
      "year": 2020,
      "value": 0.57
    },
    {
      "year": 2021,
      "value": 0.71
    },
    {
      "year": 2022,
      "value": 0.965
    },
    {
      "year": 2023,
      "value": 1.125
    },
    {
      "year": 2024,
      "value": 1.85
    }
  ],
  "tampa-bay-lightning": [
    {
      "year": 2015,
      "value": 0.26
    },
    {
      "year": 2016,
      "value": 0.305
    },
    {
      "year": 2017,
      "value": 0.39
    },
    {
      "year": 2018,
      "value": 0.445
    },
    {
      "year": 2019,
      "value": 0.47
    },
    {
      "year": 2020,
      "value": 0.47
    },
    {
      "year": 2021,
      "value": 0.65
    },
    {
      "year": 2022,
      "value": 1
    },
    {
      "year": 2023,
      "value": 1.25
    },
    {
      "year": 2024,
      "value": 1.8
    }
  ],
  "pittsburgh-penguins": [
    {
      "year": 2015,
      "value": 0.56
    },
    {
      "year": 2016,
      "value": 0.57
    },
    {
      "year": 2017,
      "value": 0.65
    },
    {
      "year": 2018,
      "value": 0.65
    },
    {
      "year": 2019,
      "value": 0.665
    },
    {
      "year": 2020,
      "value": 0.65
    },
    {
      "year": 2021,
      "value": 0.9
    },
    {
      "year": 2022,
      "value": 0.99
    },
    {
      "year": 2023,
      "value": 1.175
    },
    {
      "year": 2024,
      "value": 1.75
    }
  ],
  "colorado-avalanche": [
    {
      "year": 2015,
      "value": 0.36
    },
    {
      "year": 2016,
      "value": 0.36
    },
    {
      "year": 2017,
      "value": 0.385
    },
    {
      "year": 2018,
      "value": 0.43
    },
    {
      "year": 2019,
      "value": 0.475
    },
    {
      "year": 2020,
      "value": 0.465
    },
    {
      "year": 2021,
      "value": 0.63
    },
    {
      "year": 2022,
      "value": 0.86
    },
    {
      "year": 2023,
      "value": 1.15
    },
    {
      "year": 2024,
      "value": 1.7
    }
  ],
  "calgary-flames": [
    {
      "year": 2015,
      "value": 0.435
    },
    {
      "year": 2016,
      "value": 0.41
    },
    {
      "year": 2017,
      "value": 0.43
    },
    {
      "year": 2018,
      "value": 0.45
    },
    {
      "year": 2019,
      "value": 0.5
    },
    {
      "year": 2020,
      "value": 0.48
    },
    {
      "year": 2021,
      "value": 0.68
    },
    {
      "year": 2022,
      "value": 0.855
    },
    {
      "year": 2023,
      "value": 1.1
    },
    {
      "year": 2024,
      "value": 1.65
    }
  ],
  "seattle-kraken": [
    {
      "year": 2021,
      "value": 0.875
    },
    {
      "year": 2022,
      "value": 1.05
    },
    {
      "year": 2023,
      "value": 1.225
    },
    {
      "year": 2024,
      "value": 1.6
    }
  ],
  "minnesota-wild": [
    {
      "year": 2015,
      "value": 0.38
    },
    {
      "year": 2016,
      "value": 0.4
    },
    {
      "year": 2017,
      "value": 0.44
    },
    {
      "year": 2018,
      "value": 0.49
    },
    {
      "year": 2019,
      "value": 0.51
    },
    {
      "year": 2020,
      "value": 0.5
    },
    {
      "year": 2021,
      "value": 0.675
    },
    {
      "year": 2022,
      "value": 0.85
    },
    {
      "year": 2023,
      "value": 1.05
    },
    {
      "year": 2024,
      "value": 1.55
    }
  ],
  "nashville-predators": [
    {
      "year": 2015,
      "value": 0.255
    },
    {
      "year": 2016,
      "value": 0.27
    },
    {
      "year": 2017,
      "value": 0.38
    },
    {
      "year": 2018,
      "value": 0.425
    },
    {
      "year": 2019,
      "value": 0.46
    },
    {
      "year": 2020,
      "value": 0.435
    },
    {
      "year": 2021,
      "value": 0.6
    },
    {
      "year": 2022,
      "value": 0.81
    },
    {
      "year": 2023,
      "value": 0.975
    },
    {
      "year": 2024,
      "value": 1.5
    }
  ],
  "st-louis-blues": [
    {
      "year": 2015,
      "value": 0.27
    },
    {
      "year": 2016,
      "value": 0.31
    },
    {
      "year": 2017,
      "value": 0.45
    },
    {
      "year": 2018,
      "value": 0.465
    },
    {
      "year": 2019,
      "value": 0.53
    },
    {
      "year": 2020,
      "value": 0.51
    },
    {
      "year": 2021,
      "value": 0.64
    },
    {
      "year": 2022,
      "value": 0.88
    },
    {
      "year": 2023,
      "value": 0.99
    },
    {
      "year": 2024,
      "value": 1.45
    }
  ],
  "florida-panthers": [
    {
      "year": 2015,
      "value": 0.186
    },
    {
      "year": 2016,
      "value": 0.235
    },
    {
      "year": 2017,
      "value": 0.305
    },
    {
      "year": 2018,
      "value": 0.295
    },
    {
      "year": 2019,
      "value": 0.31
    },
    {
      "year": 2020,
      "value": 0.295
    },
    {
      "year": 2021,
      "value": 0.45
    },
    {
      "year": 2022,
      "value": 0.55
    },
    {
      "year": 2023,
      "value": 0.775
    },
    {
      "year": 2024,
      "value": 1.4
    }
  ],
  "san-jose-sharks": [
    {
      "year": 2015,
      "value": 0.445
    },
    {
      "year": 2016,
      "value": 0.47
    },
    {
      "year": 2017,
      "value": 0.49
    },
    {
      "year": 2018,
      "value": 0.51
    },
    {
      "year": 2019,
      "value": 0.54
    },
    {
      "year": 2020,
      "value": 0.515
    },
    {
      "year": 2021,
      "value": 0.625
    },
    {
      "year": 2022,
      "value": 0.74
    },
    {
      "year": 2023,
      "value": 0.9
    },
    {
      "year": 2024,
      "value": 1.35
    }
  ],
  "anaheim-ducks": [
    {
      "year": 2015,
      "value": 0.4
    },
    {
      "year": 2016,
      "value": 0.415
    },
    {
      "year": 2017,
      "value": 0.46
    },
    {
      "year": 2018,
      "value": 0.46
    },
    {
      "year": 2019,
      "value": 0.48
    },
    {
      "year": 2020,
      "value": 0.46
    },
    {
      "year": 2021,
      "value": 0.62
    },
    {
      "year": 2022,
      "value": 0.725
    },
    {
      "year": 2023,
      "value": 0.925
    },
    {
      "year": 2024,
      "value": 1.3
    }
  ],
  "carolina-hurricanes": [
    {
      "year": 2015,
      "value": 0.225
    },
    {
      "year": 2016,
      "value": 0.23
    },
    {
      "year": 2017,
      "value": 0.37
    },
    {
      "year": 2018,
      "value": 0.42
    },
    {
      "year": 2019,
      "value": 0.45
    },
    {
      "year": 2020,
      "value": 0.44
    },
    {
      "year": 2021,
      "value": 0.55
    },
    {
      "year": 2022,
      "value": 0.64
    },
    {
      "year": 2023,
      "value": 0.825
    },
    {
      "year": 2024,
      "value": 1.25
    }
  ],
  "utah-hockey-club": [
    {
      "year": 2015,
      "value": 0.22
    },
    {
      "year": 2016,
      "value": 0.24
    },
    {
      "year": 2017,
      "value": 0.3
    },
    {
      "year": 2018,
      "value": 0.29
    },
    {
      "year": 2019,
      "value": 0.3
    },
    {
      "year": 2020,
      "value": 0.285
    },
    {
      "year": 2021,
      "value": 0.4
    },
    {
      "year": 2022,
      "value": 0.45
    },
    {
      "year": 2023,
      "value": 0.5
    },
    {
      "year": 2024,
      "value": 1.2
    }
  ],
  "ottawa-senators": [
    {
      "year": 2015,
      "value": 0.37
    },
    {
      "year": 2016,
      "value": 0.355
    },
    {
      "year": 2017,
      "value": 0.42
    },
    {
      "year": 2018,
      "value": 0.435
    },
    {
      "year": 2019,
      "value": 0.445
    },
    {
      "year": 2020,
      "value": 0.43
    },
    {
      "year": 2021,
      "value": 0.525
    },
    {
      "year": 2022,
      "value": 0.8
    },
    {
      "year": 2023,
      "value": 0.95
    },
    {
      "year": 2024,
      "value": 1.15
    }
  ],
  "buffalo-sabres": [
    {
      "year": 2015,
      "value": 0.3
    },
    {
      "year": 2016,
      "value": 0.3
    },
    {
      "year": 2017,
      "value": 0.35
    },
    {
      "year": 2018,
      "value": 0.375
    },
    {
      "year": 2019,
      "value": 0.4
    },
    {
      "year": 2020,
      "value": 0.385
    },
    {
      "year": 2021,
      "value": 0.5
    },
    {
      "year": 2022,
      "value": 0.61
    },
    {
      "year": 2023,
      "value": 0.75
    },
    {
      "year": 2024,
      "value": 1.1
    }
  ],
  "winnipeg-jets": [
    {
      "year": 2015,
      "value": 0.35
    },
    {
      "year": 2016,
      "value": 0.34
    },
    {
      "year": 2017,
      "value": 0.375
    },
    {
      "year": 2018,
      "value": 0.415
    },
    {
      "year": 2019,
      "value": 0.42
    },
    {
      "year": 2020,
      "value": 0.405
    },
    {
      "year": 2021,
      "value": 0.575
    },
    {
      "year": 2022,
      "value": 0.65
    },
    {
      "year": 2023,
      "value": 0.78
    },
    {
      "year": 2024,
      "value": 1.05
    }
  ],
  "columbus-blue-jackets": [
    {
      "year": 2015,
      "value": 0.226
    },
    {
      "year": 2016,
      "value": 0.245
    },
    {
      "year": 2017,
      "value": 0.315
    },
    {
      "year": 2018,
      "value": 0.32
    },
    {
      "year": 2019,
      "value": 0.325
    },
    {
      "year": 2020,
      "value": 0.31
    },
    {
      "year": 2021,
      "value": 0.475
    },
    {
      "year": 2022,
      "value": 0.62
    },
    {
      "year": 2023,
      "value": 0.765
    },
    {
      "year": 2024,
      "value": 1
    }
  ],
  "manchester-united": [
    {
      "year": 2017,
      "value": 3.689
    },
    {
      "year": 2018,
      "value": 4.123
    },
    {
      "year": 2019,
      "value": 3.808
    },
    {
      "year": 2021,
      "value": 4.2
    },
    {
      "year": 2022,
      "value": 4.6
    },
    {
      "year": 2023,
      "value": 6
    },
    {
      "year": 2024,
      "value": 6.55
    },
    {
      "year": 2025,
      "value": 6.6
    },
    {
      "year": 2026,
      "value": 7.2
    }
  ],
  "liverpool": [
    {
      "year": 2017,
      "value": 1.492
    },
    {
      "year": 2018,
      "value": 1.944
    },
    {
      "year": 2019,
      "value": 2.183
    },
    {
      "year": 2021,
      "value": 4.1
    },
    {
      "year": 2022,
      "value": 4.45
    },
    {
      "year": 2023,
      "value": 5.288
    },
    {
      "year": 2024,
      "value": 5.37
    },
    {
      "year": 2025,
      "value": 5.4
    },
    {
      "year": 2026,
      "value": 6.2
    }
  ],
  "manchester-city": [
    {
      "year": 2017,
      "value": 2.083
    },
    {
      "year": 2018,
      "value": 2.474
    },
    {
      "year": 2019,
      "value": 2.688
    },
    {
      "year": 2021,
      "value": 4
    },
    {
      "year": 2022,
      "value": 4.25
    },
    {
      "year": 2023,
      "value": 4.99
    },
    {
      "year": 2024,
      "value": 5.1
    },
    {
      "year": 2025,
      "value": 5.3
    },
    {
      "year": 2026,
      "value": 5.5
    }
  ],
  "arsenal": [
    {
      "year": 2017,
      "value": 1.932
    },
    {
      "year": 2018,
      "value": 2.238
    },
    {
      "year": 2019,
      "value": 2.268
    },
    {
      "year": 2021,
      "value": 2.8
    },
    {
      "year": 2022,
      "value": 2.05
    },
    {
      "year": 2023,
      "value": 2.263
    },
    {
      "year": 2024,
      "value": 2.6
    },
    {
      "year": 2025,
      "value": 3.4
    },
    {
      "year": 2026,
      "value": 5.4
    }
  ],
  "chelsea": [
    {
      "year": 2017,
      "value": 1.845
    },
    {
      "year": 2018,
      "value": 2.062
    },
    {
      "year": 2019,
      "value": 2.576
    },
    {
      "year": 2021,
      "value": 3.2
    },
    {
      "year": 2022,
      "value": 3.1
    },
    {
      "year": 2023,
      "value": 3.1
    },
    {
      "year": 2024,
      "value": 3.125
    },
    {
      "year": 2025,
      "value": 3.25
    },
    {
      "year": 2026,
      "value": 4.2
    }
  ],
  "tottenham-hotspur": [
    {
      "year": 2017,
      "value": 1.058
    },
    {
      "year": 2018,
      "value": 1.237
    },
    {
      "year": 2019,
      "value": 1.624
    },
    {
      "year": 2021,
      "value": 2.3
    },
    {
      "year": 2022,
      "value": 2.35
    },
    {
      "year": 2023,
      "value": 2.803
    },
    {
      "year": 2024,
      "value": 3.2
    },
    {
      "year": 2025,
      "value": 3.3
    },
    {
      "year": 2026,
      "value": 3
    }
  ],
  "aston-villa": [
    {
      "year": 2022,
      "value": 0.75
    },
    {
      "year": 2023,
      "value": 0.756
    },
    {
      "year": 2024,
      "value": 0.8
    },
    {
      "year": 2025,
      "value": 0.9
    },
    {
      "year": 2026,
      "value": 1.4
    }
  ],
  "newcastle-united": [
    {
      "year": 2023,
      "value": 0.794
    },
    {
      "year": 2024,
      "value": 0.795
    },
    {
      "year": 2025,
      "value": 1.1
    },
    {
      "year": 2026,
      "value": 1.25
    }
  ],
  "everton": [
    {
      "year": 2026,
      "value": 0.93
    }
  ],
  "fulham": [
    {
      "year": 2024,
      "value": 0.79
    },
    {
      "year": 2025,
      "value": 0.85
    },
    {
      "year": 2026,
      "value": 0.92
    }
  ],
  "brighton-and-hove-albion": [
    {
      "year": 2024,
      "value": 0.73
    },
    {
      "year": 2025,
      "value": 0.86
    },
    {
      "year": 2026,
      "value": 0.91
    }
  ]
}
